module.exports = __webpack_public_path__ + "img/cui.c8e1d9f0.jpg";